var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.rootClass,attrs:{"data-test":"share-button","aria-label":"Share post"}},[_c('ShareIcon',{staticClass:"war-room-share-button__icon"}),_vm._v("\n  Share\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }